export default __webpack_public_path__ + "static/media/Strategy.2261ce21.jpg";